import {request, serviceUrl} from "@/utils/request";

//获取设备详情 根据id
export function getDeviceInfoById(deviceIds) {
  return request({
    params: {deviceIds},
    url: serviceUrl.deviceService + "/device/info/listByIds"
  })
}


//获取在线,离线,正常,告警设备总数并按标签分组
export function countDeviceStatusByTag() {
  return request({
    url: serviceUrl.deviceService + '/device/info/device-type-count-by-tag'
  })
}

//根据空间,标签获取在线,离线设备总数
export function countDeviceStatusBySpaceAndTag(spaceId, tagId) {
  return request({
    params: {
      spaceId,
      tagId
    },
    url: serviceUrl.deviceService + '/device/info/count-by-space-tag'
  })
}

//根据空间id、设备id集合获取设备信息
export function getDeviceListBySpaceIdAndDeviceIds(spaceId, deviceIds) {
  return request({
    params: {
      spaceId,
      deviceIds
    },
    url: serviceUrl.deviceService + '/device/info/getDeviceListBySpaceIdAndDeviceIds'
  })
}

//根据空间id或者设备类型获取设备列表
export function getDeviceList(spaceId, typeEngName = null, sysName="dcim") {
  return request({
    url: serviceUrl.deviceService + '/device/info/list',
    params: {
      spaceId,
      typeEngName,
      sysName
    }
  })
}

//获取告警的设备和等级
export function getAlarmDevices(spaceId = null, categoryTagId = null, categoryName = null) {
  return request({
    url: serviceUrl.deviceService + '/device/info/listBy/status/alarm',
    params: {
      spaceId,
      categoryTagId,
      categoryName
    }
  })
}

//设备数量统计
export function getDeviceSummary() {
  return request({
    url: serviceUrl.deviceService + '/device/info/device/summary'
  })
}

//根据空间获取设备，并根据标签分类
export function getListWithTagBySpaceId(spaceId, deviceName, typeEngName) {
  return request({
    url: serviceUrl.deviceService + '/device/info/list-with-category',
    params: {
      spaceId,
      deviceName,
      typeEngName
    }
  })
}

//根据空间id和标签id
export function getDeviceListBySpaceIdAndCategoryTagId(spaceId, categoryTagId = null, categoryTagIds = null) {
  return request({
    url: serviceUrl.deviceService + '/device/info/listBy/spaceIdAndCategoryTagId',
    params: {
      spaceId,
      categoryTagId,
      categoryTagIds,
    }
  })
}

// 根据设备id集合返回对应的设备测点值的集合
export function getDeviceValueByDeviceIds(deviceIds) {
  return request({
    url: serviceUrl.deviceService + '/device/measuring-point-history/spaceShow/pointCodes',
    params: {deviceIds}
  })
}

//获取设备详情及可视化组件
export function getDeviceInfo(id) {
  return request({
    params: {id},
    url: serviceUrl.deviceService + "/device/info/getDeviceInfo"
  })
}

//获取设备详情及可视化组件
export function getDeviceInfoVo(deviceId) {
  return request({
    params: {deviceId},
    url: serviceUrl.deviceService + "/device/info/getDeviceInfoVo"
  })
}


// 根据设备名称获取设备列表
export function getDeviceByName(spaceId, categoryIdList, name) {
  return request({
    url: serviceUrl.deviceService + '/device/info/getDeviceByName',
    params: {
      'spaceId': spaceId,
      'categoryIdList': categoryIdList,
      'name': name
    }
  });
}

// 获取用户有权限查看的设备
export function userDevice(spaceId, categoryId) {
  return request({
    url: serviceUrl.deviceService + '/device/info/userDevice',
    params: {spaceId, categoryId}
  });
}

// 根据空间id和标签id获取设备
export function getBySpaceIdAndTypId(spaceId, categoryId) {
  return request({
    url: serviceUrl.deviceService + '/device/info/getBySpaceIdAndTypId',
    params: {spaceId, categoryId}
  });
}


// 编辑设备信息
export function modifyDevice(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/info/modify',
    data: params
  })
}

// 删除设备
export function deleteDevice(deviceId) {
  return request({
    method: 'DELETE',
    url: serviceUrl.deviceService + '/device/info/delete',
    params: {deviceId}
  })
}

//根据空间id和标签id 0 正常 1 异常
export function getListBySpaceIdAndStatus(spaceId, categoryTagId = null, status = null) {
  return request({
    url: serviceUrl.deviceService + '/device/info/listBy/spaceIdAndStatus',
    params: {
      spaceId,
      categoryTagId,
      status
    }
  })
}

//根据空间id和标签id 0 正常 1 异常
export function getUserListBySpaceIdAndStatus(spaceId, categoryTagId = null, status = null, deviceName = null) {
  return request({
    url: serviceUrl.deviceService + '/device/info/listBy/spaceIdAndStatus/aboutAccount',
    params: {
      spaceId,
      categoryTagId,
      status,
      deviceName
    }
  })
}

//未绑定的设备
export function getUnboundDevices() {
  return request({
    url: serviceUrl.deviceService + '/device/info/getUnboundDevices',
  })
}

//绑定空间设备
export function boundDevices(data) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/info/boundDevices',
    data: data,
  })
}

//空间设备树
export function getSpaceDeviceTree() {
  return request({
    url: serviceUrl.deviceService + '/device/info/getSpaceDeviceTree',
  })
}

//所有的设备数据 （授权树形使用）
export function listByOrgId(orgId) {
  return request({
    url: serviceUrl.deviceService + '/device/info/listByOrgId',
    params: {orgId}
  })
}

//授权可见设备
export function authorizedDevice(spacePermission) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/info/authorizedDevice',
    data: spacePermission
  })
}

//根据主机sn获取设备列表
export function getDeviceListBySnCode(gatewaySnCode) {
  return request({
    url: serviceUrl.deviceService + '/device/info/getDeviceListBySnCode',
    params: {gatewaySnCode}
  })
}

//获取没有配置告警的设备列表
export function getUnSettingDeviceList(gatewaySnCode) {
  return request({
    url: serviceUrl.deviceService + '/device/info/getDeviceList',
    params: {gatewaySnCode}
  })
}

//获取空间能效
export function getSpaceEms(spaceId) {
  return request({
    url: serviceUrl.deviceService + '/ems/summary/monthly/getSpaceEms',
    params: {spaceId}
  })
}

//根据设备类型标识集合和空间标识查询设备
export function getByTypeIdsAndSpaceId(spaceId, deviceName, typeIdList) {
  return request({
    url: serviceUrl.deviceService + '/device/info/getByTypeIdsAndSpaceId',
    params: {
      spaceId, deviceName, typeIdList
    }
  })
}

// 导入设备
export function importDeviceExcel(form) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/info/import-excel',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: form
  })
}

// 导出设备
export function exportDeviceExcel(idList) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/info/export-excel',
    data: idList
  })
}

// 获取服务器详细信息
export function getServerUsageDetail() {
  return request({
    url: serviceUrl.deviceService + '/server/usage/detail',
  })
}

// 获取服务器详细信息前10条数据
export function getServerUsageDetailList() {
  return request({
    url: serviceUrl.deviceService + '/server/usage/detailList',
  })
}

//根据设备类型获取设备信息
export function getDeviceByTypeList(typeList,spaceId) {
  return request({
    url: serviceUrl.deviceService + '/device/info/getDeviceByTypeList',
    params: {typeList,spaceId}
  })
}


// 获取含有温湿度设备的空间信息
export function getSpacelistByTemperatureAndHumidity() {
  return request({
    url: serviceUrl.deviceService + '/device/info/listByTemperatureAndHumidity'
  })
}

// 获取含有温湿度设备的空间信息（含空调）
export function getSpacelistByTemperatureAndHumidityHistogram() {
  return request({
    url: serviceUrl.deviceService + '/device/info/listByTemperatureAndHumidityHistogram'
  })
}


// 获取机柜数量
export function getCabinetCount(spaceId) {
  return request({
    url: serviceUrl.deviceService + '/equipment/cabinet/getBySpaceId',
    params: {spaceId}
  })
}

// 获取精密配电柜数量
export function getDetailCabinetCount(spaceId,tagId) {
  return request({
    url: serviceUrl.deviceService + '/device/category/classified?spaceId='+spaceId+'&tagId='+tagId+'&deviceName='
  })
}


// 修改所有空间授权
export function updateAuthorizedAllDevice(orgId,isView) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/info/updateAuthorizedAllDevice',
    params: {orgId,isView}
  })
}
